import SectionLabel from './SectionLabel';
import founder from '../../assets/images/about/about-founder-sparsh.jpg';

const LeadershipSection = () => {
  return (
    <section className="bg-black pb-[64px] md:pb-[90px] lg:pb-[107px]">
      <div className="max-w-[1376px] mx-auto px-5 md:px-8 lg:px-0">
        <div className="grid grid-cols-1 lg:grid-cols-[403px_1fr] gap-[28px] md:gap-[40px] lg:gap-[66px] items-start">
          <img
            src={founder}
            alt="Sparsh Jain, founder of Artistto"
            className="w-full max-w-[380px] lg:max-w-none h-[360px] sm:h-[440px] lg:h-[563px] object-cover object-top"
          />

          <div className="lg:pt-[10px]">
            <SectionLabel align="left">LEADERSHIP</SectionLabel>
            <h2 className="mt-[14px] md:mt-[20px] text-white font-bold uppercase leading-none text-[34px] sm:text-[42px] md:text-[50px] lg:text-[66px] tracking-[0.02em]">
              Sparsh Jain
            </h2>
            <div className="mt-[14px] md:mt-[20px] w-[98px] h-[3px] bg-[#FF8000]" />
            <p className="mt-[14px] md:mt-[20px] text-white/60 text-[11px] md:text-[12px] lg:text-[13px] uppercase tracking-[0.16em]">
              Founder &amp; Creator
            </p>

            <div className="mt-[24px] md:mt-[36px] max-w-[640px] space-y-[18px] md:space-y-[24px]">
              <p className="text-white/70 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.62]">
                Sparsh is not just an entrepreneur; he is a creator first. As a singer-songwriter,
                producer, and mix engineer, he has lived the same journey as the artists he supports.
              </p>
              <p className="text-white/70 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.62]">
                He founded Artistto with a singular vision: to build the infrastructure he wished he
                had when he started. His background in both the creative and technical sides of music
                allows Artistto to bridge the gap between "making art" and "doing business." He
                believes that when artists are given the right ecosystem, they don't just survive,
                they define culture.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
